import { render, staticRenderFns } from "./SignUpThanksHero.vue?vue&type=template&id=405c2e18&scoped=true"
import script from "./SignUpThanksHero.vue?vue&type=script&lang=js"
export * from "./SignUpThanksHero.vue?vue&type=script&lang=js"
import style0 from "./SignUpThanksHero.vue?vue&type=style&index=0&id=405c2e18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405c2e18",
  null
  
)

export default component.exports